import { useMutation, useQueryClient } from "react-query";
import { deleteEmployeeTitle } from "../../../../../actions/Utilities/EmployeeTitle";
import { toast } from "../../../../../components/toastNotification";

export const useDeactivateEmpTitle = () => {
    const queryClient = useQueryClient();
    const { mutate } = useMutation(
        (ids: number[] | undefined) => deleteEmployeeTitle(ids),
        {
            onSuccess: () => {
              queryClient.invalidateQueries(["GetEmployeeTitle"]);
              toast.fire(
                "Success",
                "Employee Title were deactivated successfully",
                "success"
              );
            },
            onError: () => {
              toast.fire(
                "Bulk deactivation of Employee Title failed",
                "Server Error: Cannot deactivate Employee Title",
                "error"
              );
            },
        }
    )
    
    return mutate;
}

export default useDeactivateEmpTitle